var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPainSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_319_1649)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 18,
    stroke: "#3CBC37",
    strokeWidth: 3.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 41C34.2843 41 41 34.2843 41 26C41 17.7157 34.2843 11 26 11C17.7157 11 11 17.7157 11 26C11 34.2843 17.7157 41 26 41Z",
    fill: "#3CBC37",
    stroke: "#3CBC37",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35.5996C28.7543 35.5996 31.5555 33.9941 32.9159 31.455C33.3977 30.5558 32.6365 29.5996 31.6164 29.5996H20.3837C19.3636 29.5996 18.6024 30.5558 19.0841 31.455C20.4446 33.9941 23.2457 35.5996 26 35.5996Z",
    fill: "#106F0D",
    stroke: "#106F0D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 25.375C21.7557 25.375 22.875 24.2557 22.875 22.875C22.875 21.4943 21.7557 20.375 20.375 20.375C18.9943 20.375 17.875 21.4943 17.875 22.875C17.875 24.2557 18.9943 25.375 20.375 25.375Z",
    fill: "#106F0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 25.375C33.0057 25.375 34.125 24.2557 34.125 22.875C34.125 21.4943 33.0057 20.375 31.625 20.375C30.2443 20.375 29.125 21.4943 29.125 22.875C29.125 24.2557 30.2443 25.375 31.625 25.375Z",
    fill: "#106F0D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_319_1649",
    x: 0.0000243187,
    y: 0.00039053,
    width: 52,
    height: 51.9992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2,
    result: "effect1_foregroundBlur_319_1649"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPainSelected);
export default __webpack_public_path__ + "static/media/no-pain-selected.ee5ffeed9344cc4973fd83a65b3d6b56.svg";
export { ForwardRef as ReactComponent };